module.exports = __webpack_public_path__ + "static/img/mjfPurpose3.c5ac532.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mjfPurpose3.png
// module id = PES1
// module chunks = 2